export default __webpack_public_path__ + "static/media/close.414727c4.svg";